import { JawsCorrectionsBulkUploadPayload, JawsCorrectionResponse } from '@/schema/JawsCorrection';
import Api from './api';

const JawsCorrectionApi = {
  getById(id: string) {
    return Api.get<JawsCorrectionResponse>(`/jaws-corrections/${id}`);
  },

  createBulk({ data, upperJawModels, lowerJawModels }: JawsCorrectionsBulkUploadPayload) {
    if (data.corrections.length === 0) {
      return Promise.resolve([]);
    }

    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));

    upperJawModels.forEach((model, index) => {
      formData.append('upperJawModels', model, `upperJawCorrection-${index + 1}.ply`);
    });
    lowerJawModels.forEach((model, index) => {
      formData.append('lowerJawModels', model, `lowerJawCorrection-${index + 1}.ply`);
    });

    return Api.postFile<string[]>(`/jaws-corrections`, formData);
  },
};

export default JawsCorrectionApi;
